const items = ["DENIED", "DELAYED", "LOWBALLED", "LOST IN THE FINE PRINT", "ASK JACK WHAT TO DO NEXT"];

const Row = () => (
  <div className="flex items-center shrink-0">
    {items.map((item, i) => (
      <div key={i} className="flex items-center">
        <button
          type="button"
          onClick={() => window.AIWidget?.ask()}
          className={`font-display text-sm tracking-[0.4em] whitespace-nowrap px-10 cursor-pointer transition-colors duration-200 hover:text-[#FFD166] ${
            item.startsWith("ASK") ? "text-[#FFD166]" : "text-white/30"
          }`}
        >
          {item}
        </button>
        <span className="w-1.5 h-1.5 bg-[#8A2BE2]/70 rotate-45 shrink-0" />
      </div>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="hero-marquee"
    className="relative z-30 w-full overflow-hidden border-t border-white/[0.07] bg-black/80 backdrop-blur-sm py-4"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
